// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__3idT9","home__row":"Home_home__row__3PgzK","home__image":"Home_home__image__yEolv"};